import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddVariantIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 13 13",
	style: { enableBackground: "new 0 0 13 13" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.add-variant-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "add-variant-icon-st0",
		d: "M1.67773 2.92773H0.427734V11.6777C0.427734 12.3652 0.990234 12.9277 1.67773 12.9277H10.4277V11.6777H1.67773V2.92773ZM11.6777 0.427734H4.17773C3.49023 0.427734 2.92773 0.990234 2.92773 1.67773V9.17773C2.92773 9.86523 3.49023 10.4277 4.17773 10.4277H11.6777C12.3652 10.4277 12.9277 9.86523 12.9277 9.17773V1.67773C12.9277 0.990234 12.3652 0.427734 11.6777 0.427734ZM11.6777 9.17773H4.17773V1.67773H11.6777V9.17773ZM7.30273 8.55273H8.55273V6.05273H11.0527V4.80273H8.55273V2.30273H7.30273V4.80273H4.80273V6.05273H7.30273V8.55273Z"
	})]
});
export default SvgAddVariantIcon;
